import { Injectable } from "@angular/core";
import { JQueryHTTPClient } from "../../../../rest/JQueryHTTPClient";
import { EntityService } from "../../../../rest/entity.service";
import { Rest } from "../../../../rest/rest_client";

@Injectable()
export class FinanceTypeService extends EntityService<Rest.FinanceType> {
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  create(arg0: Rest.FinanceType): Rest.RestResponse<Rest.FinanceType> {
    try {
      return this.client.FinanceType_create(arg0);
    } catch (error) {
      console.error("Error creating cardType:", error);
      throw error;
    }
  }

  update(arg0: Rest.FinanceType): Rest.RestResponse<Rest.FinanceType> {
    return this.client.FinanceType_update(arg0);
  }

  getPage(
    arg0: Rest.ListPaginationRequest,
    queryParams?: { includeDisabled?: boolean }
  ): Rest.RestResponse<Rest.Page<Rest.FinanceType>> {
    return this.client.FinanceType_getPage(arg0, queryParams);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean }
  ): Rest.RestResponse<void> {
    return this.client.FinanceType_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.FinanceType> {
    return this.client.FinanceType_find(arg0, queryParams);
  }
}